module.exports = __webpack_public_path__ + "static/media/8.f4f97491.jpg";